;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sweetalert = require("sweetalert2");

var _sweetalert2 = _interopRequireDefault(_sweetalert);

var _vue2Datepicker = require("vue2-datepicker");

var _vue2Datepicker2 = _interopRequireDefault(_vue2Datepicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: { DatePicker: _vue2Datepicker2.default },
  data: function data() {
    return {
      customer_verified: false,
      is_validating: false,
      merchant_name: null,
      merchant_email: null,
      merchant_phone: null,
      merchant_address: null,
      merchant_website: null,
      merchant_id: null,
      account_id: null,
      avatar: null,
      logo: null,
      republic: null,
      surname: null,
      first_name: null,
      last_name: null,
      id_number: null,
      msisdn: null,
      invoice_items: [],
      item_desc: null,
      item_name: null,
      item_cost: null,
      item_quantity: null,
      merchants: [],
      merchant_services: [],
      service_currencies: [],
      selected_service: null,
      selected_merchant: null,
      metadata: null,
      verification_failed: false,
      verification_failed_error: null,
      due_date: null,
      api_token: "None",
      invoice_created: false,
      client_invoice_ref: null,
      consumer_secret: null,
      consumer_key: null,
      currency: null,
      default_currency: null,
      is_service_variable: false,
      all_services: [],
      allowed_merchants: [],
      notification_url: null,
      country_code: null,
      selected_invoice_type: "Select an invoice type",
      is_resident_invoice: false,
      is_foreigner_invoice: false,
      is_business_invoice: false,
      enable_invoice_id_validation: false,
      enable_invoice_passport_validation: false,
      enable_invoice_business_validation: false,
      display_service_verified: false,
      show_avatar: false,
      business_verified: false,
      can_process_invoice: false,
      service_utility_account_id: null,
      selected_utility_service_id: null,
      tax_date_period: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.consumer_secret = this.$attrs["con_secret"];
    this.consumer_key = this.$attrs["con_key"];
    this.client_invoice_ref = this.generate_req_ref();
    this.default_currency = this.$attrs["default_currency"];
    this.notification_url = this.$attrs["notification_url"];
    this.country_code = this.$attrs["country_code"];
    this.due_date = this.$attrs["duedate"];
    this.logo = this.$attrs["logo"];
    this.republic = this.$attrs["republic"];
    this.allowed_merchants = JSON.parse(this.$attrs["merchant_list"]);
    this.allowed_merchants.forEach(function (item) {
      var services = item.services;
      services.forEach(function (n) {
        var x = _this.service_currencies.indexOf(n.currency.symbol);
        if (x < 0) {
          _this.service_currencies.push(n.currency.symbol);
        }
      });
    });
  },

  methods: {
    applyFilter: function applyFilter(value) {
      if (typeof value == "undefined") {
        this.tax_date_period = null;
      } else {
        if (value[0].length <= 0 || value[1].length <= 0) {
          this.tax_date_period = null;
        } else {
          this.tax_date_period = "FROM " + value.join(" TO ");
        }
      }
    },
    set_invoice_id_validation_state: function set_invoice_id_validation_state(flag) {
      switch (flag) {
        case "false":
          this.enable_invoice_id_validation = false;
          this.customer_verified = false;
          this.avatar = this.$attrs["avatar"];
          this.display_service_verified = true;
          this.can_process_invoice = true;
          break;
        default:
          this.enable_invoice_id_validation = true;
          this.customer_verified = false;
          this.display_service_verified = false;
          this.can_process_invoice = !true;
          break;
      }
    },
    set_invoice_passport_validation_state: function set_invoice_passport_validation_state(flag) {
      switch (flag) {
        case "false":
          this.enable_invoice_passort_validation = false;
          this.customer_verified = false;
          this.avatar = this.$attrs["avatar"];
          this.display_service_verified = true;
          this.can_process_invoice = true;
          break;
        default:
          this.enable_invoice_passport_validation = true;
          this.display_service_verified = false;
          this.customer_verified = false;
          this.can_process_invoice = !true;
          break;
      }
    },
    set_invoice_business_validation_state: function set_invoice_business_validation_state(flag) {
      switch (flag) {
        case "false":
          this.enable_invoice_business_validation = false;
          this.customer_verified = false;
          this.avatar = this.$attrs["avatar"];
          this.display_service_verified = true;
          this.can_process_invoice = true;
          break;
        default:
          this.enable_invoice_business_validation = true;
          this.display_service_verified = false;
          this.customer_verified = false;
          this.can_process_invoice = !true;
          break;
      }
    },
    switchValidation: function switchValidation() {
      this.invalidate();
      switch (this.selected_invoice_type) {
        case "resident":
          this.is_resident_invoice = true;
          this.is_business_invoice = false;
          this.is_foreigner_invoice = false;
          this.set_invoice_id_validation_state(this.$attrs["enable_invoice_id_validation"]);
          break;
        case "foreigner":
          this.is_foreigner_invoice = true;
          this.is_resident_invoice = false;
          this.is_business_invoice = false;
          this.set_invoice_passport_validation_state(this.$attrs["enable_invoice_passport_validation"]);
          break;
        default:
          this.is_business_invoice = true;
          this.is_resident_invoice = false;
          this.is_foreigner_invoice = false;
          this.set_invoice_business_validation_state(this.$attrs["enable_invoice_business_validation"]);
          break;
      }
    },
    update_key_parameters: function update_key_parameters() {
      var _this2 = this;

      this.currency = null;
      this.service_currencies = [];
      if (this.selected_merchant != null) {
        this.merchant_id = this.selected_merchant.id;
        this.merchant_name = this.selected_merchant.name;
        this.merchant_email = this.selected_merchant.email;
        this.merchant_phone = this.selected_merchant.phone;
        var addr = this.selected_merchant.metadata.filter(function (m) {
          return m.item == "business_address";
        });
        if (addr.length > 0) {
          this.merchant_address = addr[0].value;
        } else {
          this.merchant_address = null;
        }
        var web = this.selected_merchant.metadata.filter(function (m) {
          return m.item == "business_url";
        });
        if (web.length > 0) {
          this.merchant_website = web[0].value;
        } else {
          this.merchant_website = null;
        }
        this.all_services = this.selected_merchant.services;
        this.all_services.forEach(function (n) {
          var x = _this2.service_currencies.indexOf(n.currency.symbol);
          if (x < 0) {
            _this2.service_currencies.push(n.currency.symbol);
          }
        });
      } else {
        this.selected_merchant = null;
      }
    },
    update_merchant_services: function update_merchant_services() {
      var _this3 = this;

      this.selected_service = null;
      this.invoice_items = [];

      if (this.selected_merchant != null) {
        this.merchant_services = this.all_services.filter(function (m) {
          return m.currency.symbol == _this3.currency;
        });
      }
    },
    set_cost_type: function set_cost_type() {
      this.item_quantity = this.item_cost = null;
      if (this.selected_service != null) {
        if (this.selected_service.cost_type == "variable") {
          this.is_service_variable = true;
        } else if (this.selected_service.cost_type == "fixed") {
          this.is_service_variable = false;
          this.item_cost = this.selected_service.cost;
        } else {
          this.is_service_variable = false;
        }
      } else {
        this.item_cost = null;
        this.is_service_variable = false;
      }
    },
    getOauthTokenAndCreateInvoice: function getOauthTokenAndCreateInvoice() {
      var _this4 = this;

      var url = "/api/oauth/generate/token";
      var payload = {
        secret: this.consumer_secret,
        key: this.consumer_key
      };
      Vue.axios.post(url, payload).then(function (response) {
        _this4.api_token = response.data.token;
        _this4.create_invoice(_this4.api_token);
      }).catch(function (error) {
        _sweetalert2.default.fire({
          icon: "error",
          title: "Oops...",
          text: "An error occurred, if this persist, kindly contact customer support. Otherwise try again"
        });
      }).then(function () {});
    },
    validate_business: function validate_business() {
      var _this5 = this;

      this.is_validating = true;
      var url = "/api/business/lookup";

      if (this.id_number == null) {
        this.is_validating = !true;
        _sweetalert2.default.fire({
          icon: "error",
          title: "Oops...",
          text: "Missing Registration Number"
        });
        return;
      }
      if (this.first_name == null) {
        this.is_validating = !true;
        _sweetalert2.default.fire({
          icon: "error",
          title: "Oops...",
          text: "Missing Business Name"
        });
        return;
      }

      var payload = {
        registration_number: this.id_number
      };
      Vue.axios.post(url, payload).then(function (response) {
        var status = response.data.status;
        if (status == "ok") {
          var business_data = response.data.business;
          if (business_data.verified) {
            _this5.can_process_invoice = true;
            _this5.display_service_verified = true;
            _this5.customer_verified = true;
            _this5.first_name = business_data.business_name;
            _this5.business_verified = true;
            _this5.is_validating = false;
          } else {
            _this5.is_validating = !true;
            _sweetalert2.default.fire({
              icon: "error",
              text: "We are unable to verify your business details. Please check if business registration is valid !"
            });
          }
        }
      }).catch(function (error) {
        _this5.is_validating = !true;
        _sweetalert2.default.fire({
          icon: "error",
          text: "We are unable to verify your business details. Please try again later."
        });
      });
    },
    validate: function validate() {
      var _this6 = this;

      if (this.id_number == null) {
        this.is_validating = !true;
        _sweetalert2.default.fire({
          icon: "error",
          title: "Oops...",
          text: "Missing ID Number"
        });
        return;
      }
      if (this.first_name == null) {
        this.is_validating = !true;
        _sweetalert2.default.fire({
          icon: "error",
          title: "Oops...",
          text: "Missing first name as provided in ID"
        });
        return;
      }
      this.is_validating = true;

      var url = "/api/customer/verification/validate";
      var payload = {
        first_name: this.first_name,
        id_number: this.id_number,
        last_name: "n/a"
      };
      Vue.axios.post(url, payload).then(function (response) {
        _this6.is_validating = false;
        _this6.customer_verified = response.data.verified;
        if (_this6.customer_verified) {
          _this6.display_service_verified = true;
          _this6.can_process_invoice = true;
          if (_this6.country_code.toLowerCase() == "ssd") {
            _this6.first_name = response.data.customer_data.last_name.toUpperCase();
            _this6.last_name = response.data.customer_data.other_names.toUpperCase();
            _this6.show_avatar = true;
            _this6.avatar = "data:image/png;base64," + response.data.customer_data.avatar;
          } else {
            _this6.first_name = response.data.customer_data.first_name.toUpperCase();
            _this6.last_name = response.data.customer_data.other_name.toUpperCase();
            _this6.avatar = _this6.$attrs["avatar"];
            _this6.show_avatar = true;
          }
        } else {
          _this6.can_process_invoice = !true;
          _this6.verification_failed = true;
          _this6.verification_failed_error = "ID Verification Failed";
        }
      }).catch(function (error) {
        _this6.can_process_invoice = !true;
        _this6.is_validating = false;
        _this6.verification_failed = true;
        _this6.verification_failed_error = "Something went wrong. Try again later";
      }).then(function () {
        _this6.is_validating = false;
      });
    },
    invalidate: function invalidate() {
      this.customer_verified = false;
      this.invoice_items = [];
      this.surname = null;
      this.first_name = null;
      this.last_name = null;
      this.msisdn = null;
      this.id_number = null;
      this.is_service_variable = false;
      this.item_quantity = null;
      this.selected_service = null;
      this.item_cost = null;
      this.selected_merchant = null;
      this.currency = null;
      this.item_desc = null;
      this.merchant_name = null;
      this.merchant_email = null;
      this.merchant_address = null;
      this.merchant_phone = null;
      this.merchant_website = null;
      this.client_invoice_ref = this.generate_req_ref();
      this.show_avatar = false;
      if (this.is_resident_invoice) {
        if (this.enable_invoice_id_validation) {
          this.can_process_invoice = !true;
        } else {
          this.can_process_invoice = true;
        }
      }
      if (this.is_foreigner_invoice) {
        if (this.enable_invoice_passort_validation) {
          this.can_process_invoice = !true;
        } else {
          this.can_process_invoice = true;
        }
      }

      if (this.is_business_invoice) {
        if (this.enable_invoice_business_validation) {
          this.can_process_invoice = !true;
        } else {
          this.can_process_invoice = true;
        }
      }
      this.selected_utility_service_id = null;
      this.service_utility_account_id = null;
      this.verification_failed_error = null;
    },
    remove: function remove(index) {
      this.item_quantity = null;
      this.selected_service = null;
      this.item_cost = null;
      this.invoice_items.splice(index, 1);
    },
    add_invoice_item: function add_invoice_item() {
      if (this.currency == null) {
        _sweetalert2.default.fire({
          icon: "error",
          title: "Oops...",
          text: "Please select a currency !"
        });
        return;
      }
      if (this.selected_service == null) {
        _sweetalert2.default.fire({
          icon: "error",
          title: "Oops...",
          text: "Please select a service to charge"
        });
        return;
      }

      this.service_utility_account_id = this.selected_service.account_id;
      this.selected_utility_service_id = this.selected_service.id;
      var service_desc = this.selected_service.name;
      if (this.is_service_variable) {
        if (this.item_desc == null || this.item_desc.length <= 0) {
          _sweetalert2.default.fire({
            icon: "error",
            title: "Oops...",
            text: "Please add a description"
          });
          return;
        }
        service_desc = service_desc + "-" + this.item_desc;
      }
      if (this.item_quantity <= 0) {
        _sweetalert2.default.fire({
          icon: "error",
          title: "Oops...",
          text: "Please select a quantity value"
        });
        return;
      }
      if (this.item_cost <= 0) {
        _sweetalert2.default.fire({
          icon: "error",
          title: "Oops...",
          text: "Invalid Cost specified. Should be greater than 0 !"
        });
        return;
      }
      this.invoice_items.push({
        item_name: service_desc,
        unit_price: this.item_cost,
        item_cost: parseFloat(this.item_cost) * this.item_quantity,
        item_quantity: this.item_quantity,
        service_id: this.selected_service.id
      });
      this.item_quantity = null;
      this.selected_service = null;
      this.item_cost = null;
    },

    generate_req_ref: function generate_req_ref() {
      var length = 6;
      var result = "";
      var characters = "ABCDEFGHIJKLMNPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz123456789";
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      return result.toUpperCase();
    },
    prepare_invoice_items: function prepare_invoice_items() {
      var _this7 = this;

      var new_items = [];
      var index = 1;
      this.invoice_items.forEach(function (item) {
        new_items.push({
          desc: item.item_name,
          price: item.unit_price,
          quantity: item.item_quantity,
          item_ref: _this7.client_invoice_ref + "_" + index,
          tax_class: null,
          service_id: item.service_id,
          settlements: [],
          require_settlements: true,
          agent_user_id: null
        });
        index++;
      });
      return new_items;
    },

    process_invoice: function process_invoice() {
      var _this8 = this;

      if (this.first_name == null || this.id_number == null) {
        _sweetalert2.default.fire({
          icon: "warning",
          title: "Oops...",
          text: "Please fill in all the invoice details !"
        });
        return;
      }

      if (this.invoice_items.length <= 0) {
        _sweetalert2.default.fire({
          icon: "warning",
          title: "Oops...",
          text: "Invoice must have valid items !"
        });
        return;
      }
      _sweetalert2.default.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, proceed",
        showLoaderOnConfirm: true,
        preConfirm: function preConfirm(login) {
          return _this8.getOauthTokenAndCreateInvoice();
        },
        allowOutsideClick: function allowOutsideClick() {
          return !_sweetalert2.default.isLoading();
        }
      }).then(function (result) {});
    },
    clean_null_entries: function clean_null_entries(v) {
      if (v == null) return "";
      return v;
    },
    verify_msisdn: function verify_msisdn(msisdn) {
      if (msisdn == null || msisdn === "") {
        return "N/A";
      }
      return msisdn;
    },
    create_invoice: function create_invoice(token) {
      var _this9 = this;

      if (this.currency == null) {
        _sweetalert2.default.fire({
          icon: "error",
          title: "Oops...",
          text: "You haven't selected a currency !"
        });
        return;
      }

      var api_url = "/api/invoice/ui/create";
      var payload = {
        name: this.clean_null_entries(this.first_name) + " " + this.clean_null_entries(this.last_name),
        client_invoice_ref: this.client_invoice_ref,
        meta_data: {
          customer_msisdn: this.verify_msisdn(this.msisdn),
          tax_period: this.tax_date_period
        },
        msisdn: null,
        merchant_id: this.merchant_id,
        id_number: this.id_number,
        amount_expected: this.total,
        currency: this.currency,
        items: this.prepare_invoice_items(this.invoice_items),
        notification_url: this.notification_url,
        amount_settled_offline: 0
      };
      var api_headers = { Authorization: "Bearer " + token };
      var result = false;
      Vue.axios.post(api_url, payload, { headers: api_headers }).then(function (response) {
        if (response.data.status == 200) {
          _this9.invalidate();
          window.location.href = "/invoice/" + response.data.invoice.id;
        } else {
          _sweetalert2.default.fire({
            icon: "error",
            title: "Oops...",
            text: "Unable to submit invoice. Contact Support for further assistance"
          });
        }
      }).catch(function (error) {
        _sweetalert2.default.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong. Contact Support for further assistance"
        });
      }).then(function () {});

      return result;
    }
  },
  computed: {
    total: function total() {
      var sum = 0;
      return this.invoice_items.reduce(function (sum, item) {
        return sum + item.item_cost;
      }, 0);
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-lg-12 col-xl-12"},[_c('div',{staticClass:"header mt-md-5"},[_c('div',{staticClass:"header-body"},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col"},[_c('h6',{staticClass:"header-pretitle"},[_vm._v("Invoices")]),_vm._v(" "),_c('h1',{staticClass:"header-title"},[_vm._v("\n                Invoice #INV-"+_vm._s(_vm.client_invoice_ref)+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('v-select',{attrs:{"options":_vm.allowed_merchants,"label":"name","placeholder":"Select Merchant"},on:{"change":_vm.update_key_parameters},model:{value:(_vm.selected_merchant),callback:function ($$v) {_vm.selected_merchant=$$v},expression:"selected_merchant"}})],1),_vm._v(" "),_c('div',{staticClass:"col-2"},[_c('v-select',{attrs:{"options":_vm.service_currencies,"placeholder":"Select Currency"},on:{"change":_vm.update_merchant_services},model:{value:(_vm.currency),callback:function ($$v) {_vm.currency=$$v},expression:"currency"}})],1)])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-xl-3"},[_c('div',{staticClass:"col-12"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected_invoice_type),expression:"selected_invoice_type"}],staticClass:"form-control",attrs:{"tabindex":"-1"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected_invoice_type=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.switchValidation]}},[_c('option',{attrs:{"disabled":""}},[_vm._v("Whom is the Invoice For ?")]),_vm._v(" "),_c('option',{attrs:{"value":"foreigner"}},[_vm._v("Foreigner")]),_vm._v(" "),_c('option',{attrs:{"value":"resident"}},[_vm._v("Resident")]),_vm._v(" "),_c('option',{attrs:{"value":"business"}},[_vm._v("Business")])]),_vm._v(" "),_c('hr')]),_vm._v(" "),(_vm.show_avatar)?_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body text-center"},[_c('a',{staticClass:"avatar avatar-xl mb-3",attrs:{"href":"#"}},[_c('img',{staticClass:"avatar-img rounded-circle border border-4 border-card",attrs:{"src":_vm.avatar,"alt":"..."}})]),_vm._v(" "),_c('h2',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.first_name)+" "+_vm._s(_vm.last_name))]),_vm._v(" "),_c('p',{staticClass:"small text-muted mb-3"},[_vm._v("\n            +"+_vm._s(_vm.msisdn)+" "),_c('br'),_vm._v("\n            "+_vm._s(_vm.id_number)+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"card-body py-3"},[_c('div',{staticClass:"list-group list-group-flush"},[_c('div',{staticClass:"list-group-item border-top"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col text-right"},[_c('a',{staticClass:"btn btn-sm btn-danger",attrs:{"href":"javascript:void(0)"},on:{"click":_vm.invalidate}},[_vm._v("Remove")])])])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12 col-xl-12"},[(_vm.verification_failed)?_c('p',{staticClass:"alert alert-danger"},[_vm._v("\n          "+_vm._s(_vm.verification_failed_error)+"\n        ")]):_vm._e()]),_vm._v(" "),(!_vm.customer_verified && _vm.is_resident_invoice)?_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('form',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"message-text"}},[_vm._v("Enter Mobile Number")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.msisdn),expression:"msisdn"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Mobile Number","maxlength":"20"},domProps:{"value":(_vm.msisdn)},on:{"input":function($event){if($event.target.composing){ return; }_vm.msisdn=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"message-text"}},[_vm._v("Enter Personal/ID Number")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.id_number),expression:"id_number"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"ID Number","maxlength":"20"},domProps:{"value":(_vm.id_number)},on:{"input":function($event){if($event.target.composing){ return; }_vm.id_number=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"recipient-name"}},[_vm._v("First Name (As in ID)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.first_name),expression:"first_name"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"First name as in ID","maxlength":"20"},domProps:{"value":(_vm.first_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.first_name=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"recipient-name"}},[_vm._v("Period (Tax Only)")]),_vm._v(" "),_c('date-picker',{attrs:{"type":"date","placeholder":"Select Date","lang":"en","range-separator":"-","input-class":"form-control","format":"DD/MMM/YYYY","value-type":"format","shortcuts":false,"confirm":true,"range":true},on:{"confirm":_vm.applyFilter,"clear":_vm.applyFilter},model:{value:(_vm.tax_date_period),callback:function ($$v) {_vm.tax_date_period=$$v},expression:"tax_date_period"}})],1),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"col-4"},[(_vm.enable_invoice_id_validation)?_c('a',{staticClass:"btn btn-sm btn-outline-primary lift",attrs:{"href":"javascript:void(0)"},on:{"click":_vm.validate}},[_vm._v("Validate")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-4"},[(_vm.is_validating)?_c('span',{staticClass:"fa fa-spinner fa-spin"}):_vm._e()])])])]),_vm._v(" "),_vm._m(0)]):_vm._e(),_vm._v(" "),(!_vm.customer_verified && _vm.is_foreigner_invoice)?_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('form',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"message-text"}},[_vm._v("Enter Mobile Number")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.msisdn),expression:"msisdn"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Mobile Number","maxlength":"20","required":""},domProps:{"value":(_vm.msisdn)},on:{"input":function($event){if($event.target.composing){ return; }_vm.msisdn=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"message-text"}},[_vm._v("Enter Passport Number")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.id_number),expression:"id_number"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"ID Number","maxlength":"20","required":""},domProps:{"value":(_vm.id_number)},on:{"input":function($event){if($event.target.composing){ return; }_vm.id_number=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"recipient-name"}},[_vm._v("Full Name (As in Passport)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.first_name),expression:"first_name"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Full Name","maxlength":"20","required":""},domProps:{"value":(_vm.first_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.first_name=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"recipient-name"}},[_vm._v("Period (Tax Only)")]),_vm._v(" "),_c('date-picker',{attrs:{"type":"date","placeholder":"Select Date","lang":"en","range-separator":"-","input-class":"form-control","format":"DD/MMM/YYYY","value-type":"format","shortcuts":false,"confirm":true,"range":true},on:{"confirm":_vm.applyFilter,"clear":_vm.applyFilter},model:{value:(_vm.tax_date_period),callback:function ($$v) {_vm.tax_date_period=$$v},expression:"tax_date_period"}})],1),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"col-4"},[(_vm.enable_invoice_passport_validation)?_c('a',{staticClass:"btn btn-sm btn-outline-primary lift",attrs:{"href":"javascript:void(0)"},on:{"click":_vm.validate}},[_vm._v("Validate")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-4"},[(_vm.is_validating)?_c('span',{staticClass:"fa fa-spinner fa-spin"}):_vm._e()])])])]),_vm._v(" "),_vm._m(1)]):_vm._e(),_vm._v(" "),(!_vm.customer_verified && _vm.is_business_invoice)?_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('form',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"message-text"}},[_vm._v("Enter Mobile Number")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.msisdn),expression:"msisdn"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Mobile Number","maxlength":"20","required":""},domProps:{"value":(_vm.msisdn)},on:{"input":function($event){if($event.target.composing){ return; }_vm.msisdn=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"message-text"}},[_vm._v("Business Registration Number")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.id_number),expression:"id_number"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Business Registration Number","maxlength":"20"},domProps:{"value":(_vm.id_number)},on:{"input":function($event){if($event.target.composing){ return; }_vm.id_number=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"recipient-name"}},[_vm._v("Business Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.first_name),expression:"first_name"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Business Name","maxlength":"20"},domProps:{"value":(_vm.first_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.first_name=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"recipient-name"}},[_vm._v("Period (Tax Only)")]),_vm._v(" "),_c('date-picker',{attrs:{"type":"date","placeholder":"Select Date","lang":"en","range-separator":"-","input-class":"form-control","format":"DD/MMM/YYYY","value-type":"format","shortcuts":false,"confirm":true,"range":true},on:{"confirm":_vm.applyFilter,"clear":_vm.applyFilter},model:{value:(_vm.tax_date_period),callback:function ($$v) {_vm.tax_date_period=$$v},expression:"tax_date_period"}})],1),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"col-4"},[(_vm.enable_invoice_business_validation)?_c('a',{staticClass:"btn btn-sm btn-outline-primary lift",attrs:{"href":"javascript:void(0)"},on:{"click":_vm.validate_business}},[_vm._v("Validate")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-4"},[(_vm.is_validating)?_c('span',{staticClass:"fa fa-spinner fa-spin"}):_vm._e()])])])]),_vm._v(" "),_vm._m(2)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-12 col-xl-9"},[_c('div',{staticClass:"card card-body p-5"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col text-center"},[_c('img',{attrs:{"src":_vm.logo,"alt":"..."}}),_vm._v(" "),_c('h2',{staticClass:"mb-2"},[_vm._v("\n              "+_vm._s(_vm.republic)+"\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6"},[_c('h6',{staticClass:"text-uppercase text-muted"},[_vm._v("Invoiced from")]),_vm._v(" "),_c('p',{staticClass:"text-muted mb-4"},[_c('strong',{staticClass:"text-body"},[_vm._v(_vm._s(_vm.merchant_name))]),_vm._v(" "),_c('br'),_vm._v("\n              "+_vm._s(_vm.merchant_address)+" "),_c('br'),_vm._v("\n              +"+_vm._s(_vm.merchant_phone)+" "),_c('br'),_vm._v("\n              "+_vm._s(_vm.merchant_email)+" "),_c('br'),_vm._v("\n              "+_vm._s(_vm.merchant_website)+"\n            ")]),_vm._v(" "),_c('h6',{staticClass:"text-uppercase text-muted"},[_vm._v("Invoiced ID")]),_vm._v(" "),_c('p',{staticClass:"mb-4"},[_vm._v("#INV-"+_vm._s(_vm.client_invoice_ref))]),_vm._v(" "),(_vm.tax_date_period)?_c('h6',{staticClass:"text-uppercase text-muted"},[_vm._v("Period")]):_vm._e(),_vm._v(" "),(_vm.tax_date_period)?_c('p',{staticClass:"mb-4"},[_vm._v(_vm._s(_vm.tax_date_period))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 text-md-right"},[_c('h6',{staticClass:"text-uppercase text-muted"},[_vm._v("Invoiced to")]),_vm._v(" "),_c('p',{staticClass:"text-muted mb-4"},[_c('strong',{staticClass:"text-body"},[_vm._v(_vm._s(_vm.first_name)+" "+_vm._s(_vm.last_name))]),_vm._v(" "),_c('br'),_vm._v("\n              +"+_vm._s(_vm.msisdn)+" "),_c('br'),_vm._v("\n              "+_vm._s(_vm.id_number)+"\n            ")]),_vm._v(" "),_c('h6',{staticClass:"text-uppercase text-muted"},[_vm._v("Due date")]),_vm._v(" "),_c('p',{staticClass:"mb-4"},[_c('time',{attrs:{"datetime":"2018-04-23"}},[_vm._v(_vm._s(_vm.due_date))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table my-4"},[_vm._m(4),_vm._v(" "),_c('tbody',[_vm._l((_vm.invoice_items),function(q,key){return _c('tr',{key:key},[_c('td',{staticClass:"px-0"},[_vm._v(_vm._s(q.item_name))]),_vm._v(" "),_c('td',{staticClass:"px-0"},[_vm._v(_vm._s(q.item_quantity))]),_vm._v(" "),_c('td',{staticClass:"px-0 text-right"},[_vm._v(_vm._s(q.unit_price))]),_vm._v(" "),_c('td',{staticClass:"px-0 text-right"},[_vm._v(_vm._s(q.item_cost))]),_vm._v(" "),_c('td',{staticClass:"px-0 text-right"},[_c('button',{on:{"click":function($event){_vm.remove(key)}}},[_vm._v("X")])])])}),_vm._v(" "),_c('tr',[_vm._m(5),_vm._v(" "),_c('td',{attrs:{"colspan":"2"}}),_vm._v(" "),_c('td',{staticClass:"px-0 text-right border-top border-top-2",attrs:{"colspan":"2"}},[_c('span',{staticClass:"h3"},[_vm._v(" "+_vm._s(_vm.total)+" ")])])])],2)])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.display_service_verified)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-7"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"col-auto"},[_c('label',[_vm._v("Select Service")]),_vm._v(" "),_c('v-select',{attrs:{"options":_vm.merchant_services,"label":"name"},on:{"change":_vm.set_cost_type},model:{value:(_vm.selected_service),callback:function ($$v) {_vm.selected_service=$$v},expression:"selected_service"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"col-2"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"col-auto"},[_c('label',[_vm._v("Quantity")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item_quantity),expression:"item_quantity"}],staticClass:"form-control",attrs:{"type":"number","min":"1","placeholder":"1"},domProps:{"value":(_vm.item_quantity)},on:{"input":function($event){if($event.target.composing){ return; }_vm.item_quantity=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"col-2"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"col-auto"},[_c('label',[_vm._v("Unit.Cost")]),_vm._v(" "),(_vm.is_service_variable)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item_cost),expression:"item_cost"}],staticClass:"form-control",attrs:{"type":"number","placeholder":"1","min":"1"},domProps:{"value":(_vm.item_cost)},on:{"input":function($event){if($event.target.composing){ return; }_vm.item_cost=$event.target.value}}}):_vm._e(),_vm._v(" "),(!_vm.is_service_variable)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item_cost),expression:"item_cost"}],staticClass:"form-control",attrs:{"type":"number","placeholder":"1","min":"1","readonly":""},domProps:{"value":(_vm.item_cost)},on:{"input":function($event){if($event.target.composing){ return; }_vm.item_cost=$event.target.value}}}):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-end align-items-center"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.add_invoice_item}},[_vm._v("\n              Add\n            ")])])]):_vm._e(),_vm._v(" "),(_vm.is_service_variable)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item_desc),expression:"item_desc"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Enter item description","required":""},domProps:{"value":(_vm.item_desc)},on:{"input":function($event){if($event.target.composing){ return; }_vm.item_desc=$event.target.value}}})])]):_vm._e()]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"d-flex flex-row-reverse"},[(_vm.can_process_invoice)?_c('button',{staticClass:"p-2 btn btn-primary",on:{"click":_vm.process_invoice}},[_vm._v("\n          Create Invoice\n        ")]):_vm._e()]),_vm._v(" "),_c('hr')])])])}
__vue__options__.staticRenderFns = [function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-body py-3"},[_c('div',{staticClass:"list-group list-group-flush"},[_c('div',{staticClass:"list-group-item border-top"})])])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-body py-3"},[_c('div',{staticClass:"list-group list-group-flush"},[_c('div',{staticClass:"list-group-item border-top"})])])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-body py-3"},[_c('div',{staticClass:"list-group list-group-flush"},[_c('div',{staticClass:"list-group-item border-top"})])])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col text-right"})])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"px-0 bg-transparent border-top-0"},[_c('span',{staticClass:"h6"},[_vm._v("Description")])]),_vm._v(" "),_c('th',{staticClass:"px-0 bg-transparent border-top-0"},[_c('span',{staticClass:"h6"},[_vm._v("Quantity")])]),_vm._v(" "),_c('th',{staticClass:"px-0 bg-transparent border-top-0 text-right"},[_c('span',{staticClass:"h6"},[_vm._v("Price")])]),_vm._v(" "),_c('th',{staticClass:"px-0 bg-transparent border-top-0 text-right"},[_c('span',{staticClass:"h6"},[_vm._v("Total Cost")])]),_vm._v(" "),_c('th',{staticClass:"px-0 bg-transparent border-top-0 text-right"})])])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"px-0 border-top border-top-2"},[_c('strong',[_vm._v("Total amount due")])])}]
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-65204da7", __vue__options__)
  } else {
    hotAPI.reload("data-v-65204da7", __vue__options__)
  }
})()}